import { Component, Input, OnInit } from '@angular/core';

import { Observable } from 'rxjs';

import { AbstractDialogComponent } from '../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../Core/Dialogs/services/dialog.service';
import { BrandIdentity } from '../../../Common/BrandIdentity/models/brand-identity';

import { ButtonTypesEnum } from '../../../Common/Forms/enums/button-types.enum';

import { BrandCompetitor } from '../../../api/brandIdentity/models/brand-identity.api.model';
import { ViMonitor } from '../../models/vi-monitor.model';

export interface ViCompetitorsSetupPanelResult {
    isCompetitiveBenchmarking: boolean;
    competitors: BrandCompetitor[];
}

@Component({
    selector: 'agpr-vi-competitors-setup-panel',
    templateUrl: './vi-competitors-setup-panel.component.html',
    styleUrls: ['./vi-competitors-setup-panel.component.scss'],
    standalone: false
})
export class ViCompetitorsSetupPanelComponent extends AbstractDialogComponent implements OnInit {
    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<any>;
    @Input() brand: BrandIdentity;
    @Input() monitor: ViMonitor;

    readonly id: string = 'viCompetitorsSetupPanel';
    readonly buttonTypes = ButtonTypesEnum;

    confirmed: boolean = false;
    hideSlideOverlay: boolean = false;

    isCompetitiveBenchmarking: boolean = false;
    competitors: BrandCompetitor[] = [];

    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService, 'ViCompetitorsSetupPanel');
    }

    ngOnInit(): void {
        this.isCompetitiveBenchmarking = !!this.monitor?.isCompetitiveBenchmarking;
        this.competitors = [...(this.brand?.competitors ?? [])];
    }

    continue(): void {
        this.confirmed = true;
        this.hideSlideOverlay = true;
    }

    skip(): void {
        this.isCompetitiveBenchmarking = false;
        this.confirmed = true;
        this.hideSlideOverlay = true;
    }

    onVisibleChange(visible: boolean): void {
        if (!visible) {
            const result: ViCompetitorsSetupPanelResult | null = this.confirmed
                ? {
                    isCompetitiveBenchmarking: this.isCompetitiveBenchmarking,
                    competitors: this.isCompetitiveBenchmarking ? this.competitors : []
                } : null;
            this.closeDialog(result);
        }
    }
}
